// @ts-nocheck
import React from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Icon,
  Input,
  InputAdornment,
  TableSortLabel,
  Typography,
  Pagination,
  PaginationItem,
  useMediaQuery
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import WestIcon from "@mui/icons-material/West";
import SortArrow from "../../../assets/images/sort-arrow.svg";
import TableBody from "@mui/material/TableBody";
import { useTheme } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { ArrowBack, ArrowForward, Close, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "../../event-request/EventRequests.css";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";

// icons
import { getContractorEventsAction } from "../../../store/actions/opportunities";
import EventResourceTab from "../../event-details/components/EventResources";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import GenericTransparentBtn from "../../../components/Custom/GenericTransparentBtn";
import { inputRegex } from "../../../utils/constants/inputRegex";
import { rowsPerPageInit } from "../../../utils/constants/paginationConstants";
import { onSubmitFormNoAction } from "../../../utils/methods/eventUtils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&.rejected": {
    backgroundColor: "#ed101070"
  }
  // hide last border
  // "&:last-child td, &:last-child th": {
  //   border: 0,
  // },
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main
  }
}));

export const ContractorResources = () => {
  const dispatch = useDispatch();
  const dataRowsPerPage = 10;

  const navigate = useNavigate();

  // Refs start...
  const initialRef = React.useRef(true);
  const tabInitialRef = React.useRef(true);
  // Refs end...

  // Selectors start...
  const {
    opportunitiesApp,
    isLoading,
    events,
    eventTotalPages: totalPages,
    eventCurrentPage: currentPage,
    searchString
  } = useSelector((state) => state.opportunities);
  const { userRole } = useSelector((state) => state.auth);
  // Selectors end...

  // State variables start...
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(currentPage || 1);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageInit);
  const [filterParams, setFilterParams] = useState({
    sortOrder: "",
    sortField: ""
  });
  const [order, setOrder] = useState("asc");
  const [searchStr, setSearchStr] = useState(searchString?.event || "");
  const [isViewResources, setIsViewResources] = useState({
    status: false,
    data: null
  });
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // State variables end...

  React.useEffect(() => {
    if (events?.length > 0) return;
    fetchPaginationDataHandler({});
    // dispatch(
    //   getContractorEventsAction({
    //     payload: {
    //       params: {
    //         // page: 1,
    //         // limit: dataRowsPerPage,
    //       },
    //     },
    //   }),
    // );
  }, []);

  React.useEffect(() => {
    if (initialRef.current) return;
    fetchPaginationDataHandler({});
  }, [filterParams, page, rowsPerPage]);

  React.useEffect(() => {
    if (initialRef.current) {
      initialRef.current = false;
      return;
    }
    const debounce = setTimeout(() => {
      fetchPaginationDataHandler({
        params: {
          page: 1
        },
        successCallback: () => {
          setPage(1);
        }
      });
      // if (!searchStr || searchStr === "") {
      //   setRows(events);
      //   setPage(1);
      // } else {
      //   if (events?.length === 0) {
      //     setRows([]);
      //   } else {
      //     const newRows = events?.filter(
      //       (item) =>
      //         item?.positionName
      //           ?.toLowerCase()
      //           .includes(searchStr.toLowerCase()) ||
      //         item?.eventName
      //           ?.toLowerCase()
      //           .includes(searchStr.toLowerCase()) ||
      //         item?.venue?.toLowerCase().includes(searchStr.toLowerCase()),
      //     );
      //     setRows(newRows);
      //     setPage(1);
      //   }
      // }
    }, [300]);

    return () => {
      clearTimeout(debounce);
    };
  }, [searchStr]);

  React.useEffect(() => {
    setRows(events);
  }, [events]);


  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const fetchPaginationDataHandler = ({ params, successCallback }) => {
    dispatch(
      getContractorEventsAction({
        params: {
          page,
          limit: rowsPerPage,
          search: searchStr,
          ...(filterParams || {}),
          ...(params || {})
        },
        successCallback
      })
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // if (!searchStr || searchStr === "") {
    //   setRows(events);
    //   setPage(newPage);
    // } else {
    //   const newRows = events?.filter((item) => {
    //     return (
    //       item.positionName.toLowerCase().includes(searchStr.toLowerCase()) ||
    //       item.eventName.toLowerCase().includes(searchStr.toLowerCase()) ||
    //       item.venue.toLowerCase().includes(searchStr.toLowerCase())
    //     );
    //   });
    //   setPage(newRows);
    //   setPage(newPage);
    // }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSortRequest = ({ cb, field }) => {
    const newOrder = filterParams?.sortOrder === "asc" ? "desc" : "asc";
    setFilterParams((filterParams) => {
      return {
        ...filterParams,
        sortOrder: newOrder,
        sortField: field
      };
    });
    // const sortedRows = [...rows].sort((a, b) => {
    //   const aValue = cb ? cb({ row: a }) : a.name;
    //   const bValue = cb ? cb({ row: b }) : b.name;

    //   if (newOrder === "asc") {
    //     if (aValue < bValue) {
    //       return -1;
    //     }
    //     if (aValue > bValue) {
    //       return 1;
    //     }
    //     return 0;
    //   } else {
    //     if (aValue < bValue) {
    //       return 1;
    //     }
    //     if (aValue > bValue) {
    //       return -1;
    //     }
    //     return 0;
    //   }
    // });
    // setRows(sortedRows);
    // setOrder(newOrder);
  };

  const handleSearch = (e) => {
    const value = e?.target?.value?.replace(inputRegex, "");
    setSearchStr(value);
  };

  if (isViewResources?.status) {
    return (
      <Box
        sx={{
          padding: "15px "
        }}
      >
        <Box
          sx={{
            padding: "20px 0px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "20px"
          }}
        >
          <Button
            onClick={() => setIsViewResources({ status: false, data: null })}
            sx={{
              minWidth: "0",
              background: "none",
              padding: "0.5rem",
              boxShadow: "none",
              border: `1px solid ${getCssVariableHandler({
                variableName: "--primary-pink-hex"
              })}`,
              zIndex: "2",
              borderRadius: "50%",
              cursor: "pointer !important",
              "&:hover": {
                minWidth: "0",
                background: "none",
                padding: "0.5rem",
                boxShadow: "none",
                border: `1px solid ${getCssVariableHandler({
                  variableName: "--primary-pink-hex"
                })}`,
                borderRadius: "50%"
              }
            }}
          >
            <WestIcon />
          </Button>
          <Typography variant="h1">
            {isViewResources?.data?.positionName}
            <Typography
              variant="h2"
              sx={{ color: "#00EEC5", display: "inline-flex" }}
            >
              ({isViewResources?.data?.eventName})
            </Typography>
          </Typography>
        </Box>
        <EventResourceTab eventId={isViewResources?.data?.eventId} />
      </Box>
    );
  }


  return (
    <>
      <Box
        sx={{
          padding: "20px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "@media (max-width: 600px)": {
            flexDirection: "column",
            padding: "20px 20px"
          }
        }}
      >
        <Typography
          variant={isSmallScreen ? "h3" : "h1"}
          sx={{
            "@media (max-width: 600px)": {
              marginBottom: "15px"
            }
          }}
        >
          Resources
        </Typography>
        <form autoComplete="off" onSubmit={onSubmitFormNoAction}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& .MuiInputBase-root": {
                border: "1px solid #FFF !important",
                background: "rgba(0, 0, 0, 0.01) !important",
                boxShadow:
                  "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                borderRadius: "8px",
                padding: "5px 24px 5px 16px",
                "&:before": {
                  content: "none"
                },
                "&:after": {
                  content: "none"
                },
                "& svg": {
                  color: "#ffffff"
                },
                "& input": {
                  color: "#ffffff"
                }
              }
            }}
          >
            <Input
              id="input-with-icon-adornment"
              onChange={handleSearch}
              value={searchStr}
              placeholder="Search here"
              // startAdornment={
              //   <InputAdornment position="start">
              //     <Search />
              //   </InputAdornment>
              // }
              endAdornment={
                <InputAdornment position="start">
                  {!searchStr ? (
                    <Search
                      sx={{
                        fontSize: "1.25rem"
                        // marginRight: "0.7rem"
                      }}
                    />
                  ) : (
                    <GenericTransparentBtn
                      onClick={() => {
                        setSearchStr("");
                      }}
                      style={{
                        background: "grey",
                        padding: "0.10rem",
                        borderRadius: "50%",
                        onHover: {
                          background: "grey",
                          padding: "0.10rem"
                        }
                      }}
                    >
                      <Close
                        sx={{
                          fontSize: "1rem"
                          // marginRight: "0.7rem"
                        }}
                      />
                    </GenericTransparentBtn>
                  )}
                </InputAdornment>
              }
              sx={{
                paddingLeft: "1rem !important",
                border: "1px solid #FFF !important",
                "@media (max-width: 1000px)": {
                  flexGrow: "1"
                  // width: "70%"
                }
              }}
            />
          </Box>
        </form>
      </Box>
      <Box>
        {isLoading ? (
          <LoadingOverlay open={isLoading} />
        ) : (
          <Box>
            <TableContainer
              className="custom-scroll-design"
              sx={{
                maxWidth: "100%",
                ...(isSmallScreen
                  ? {
                      minHeight: "calc(100vh - 323px)"
                    }
                  : {
                      height: "88vh"
                    }),
                overscrollBehavior: "auto"
              }}
            >
              <Table sx={{}} aria-label="sticky table" stickyHeader>
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        backgroundColor: "#D175B6 !important",
                        padding: "2px 15px",
                        fontSize: "20px",
                        color: "#ffffff",
                        borderColor: "#D175B6",
                        "& span": {
                          color: "#ffffff !important"
                        }
                      },
                      "& th:not(:last-child)": {
                        paddingRight: "0 !important"
                      }
                    }}
                  >
                    <StyledTableCell>
                      <TableSortLabel
                        sx={{
                          padding: "2px 0 2px 20px !important",
                          textWrap: "nowrap"
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "positionName"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.positionName?.toLowerCase();
                            },
                            field: "positionName"
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Position Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        sx={{
                          padding: "2px 0 2px 0",
                          textWrap: "nowrap"
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "eventName"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.eventName?.toLowerCase();
                            },
                            field: "eventName"
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Event Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        sx={{
                          textWrap: "nowrap"
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "eventStart"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.eventStart;
                            },
                            field: "eventStart"
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Start Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        sx={{
                          textWrap: "nowrap"
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "eventEnd"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.eventEnd;
                            },
                            field: "eventEnd"
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        End Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        sx={{
                          textWrap: "nowrap"
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "venue"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.venue?.toLowerCase();
                            },
                            field: "venue"
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Venue
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  sx={{
                    "& td": {
                      borderColor: "#D175B6",
                      color: "#ffffff",
                      "& td": {}
                    }
                  }}
                >
                  {rows?.length === 0 ? (
                    <StyledTableRow
                    // className={row?.isRejected ? "rejected" : ""}
                    >
                      <StyledTableCell colSpan={12}>
                        <Typography
                          sx={{
                            textAlign: "center"
                          }}
                        >
                          No records
                        </Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    rows?.map((row, index) => (
                      <StyledTableRow
                        key={index}
                        // className={row?.isRejected ? "rejected" : ""}
                      >
                        <StyledTableCell>
                          <Typography
                            sx={{
                              wordBreak: "break-all",
                              display: "flex",
                              alignItems: "center",
                              marginLeft: "20px",
                              "& a": {
                                lineHeight: "0"
                              },
                              "& img": {
                                // marginRight: "10px",
                              }
                            }}
                          >
                            {row?.positionName}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography
                            sx={{
                              wordBreak: "break-all",
                              display: "flex",
                              alignItems: "center",
                              // marginLeft: "30px",
                              "& a": {
                                lineHeight: "0"
                              },
                              "& img": {
                                marginRight: "10px"
                              }
                            }}
                          >
                            {row?.eventName}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography>
                            {getUniversalDateTimeFormat({
                              dateTime: row?.eventStart
                            })}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography>
                            {getUniversalDateTimeFormat({
                              dateTime: row?.eventEnd
                            })}
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography
                            sx={{
                              wordBreak: "break-all"
                            }}
                          >
                            {`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                          </Typography>
                          {/* <LineClamp
                            text={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                            maxLines={1}
                          /> */}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Typography
                            sx={{
                              // wordBreak: "break-all"
                              textWrap: "nowrap"
                            }}
                          >
                            {row?.reponse?.pending ? (
                              row?.clientDetail?.firstName +
                              " " +
                              row?.clientDetail?.lastName
                            ) : (
                              <span
                                className="assign_client"
                                onClick={() => {
                                  setIsViewResources({
                                    status: true,
                                    data: row
                                  });
                                }}
                              >
                                View Resouces
                              </span>
                            )}
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                "& td": {
                  display: "block"
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "black",
                borderRadius: "0px 0px 15px 15px",
                borderTop: "1px solid #D175B6"
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handleChangePage}
                siblingCount={isSmallScreen ? 0 : 1}
                renderItem={(item) => (
                  <StyledPaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};